<template>
  <div id="root">
    <!-- 主应用布局 -->
    <keep-alive>
      <!--使用keep-alive会将页面缓存-->
      <a-config-provider :locale="locale"
        ><router-view v-if="$route.meta.keepAlive && isRouterAlive"
      /></a-config-provider>
    </keep-alive>
    <component :is="layout" :style="{ height: `${$route.name ? '' : 0}` }">
      <a-config-provider :locale="locale">
        <router-view v-if="!$route.meta.keepAlive && isRouterAlive"
      /></a-config-provider>
    </component>
    <!-- 子应用布局 -->
    <section
      v-show="!$route.meta.frame"
      class="sub-app-container"
      :style="
        layout !== 'div'
          ? `height: calc(100vh - 17px); padding-left: ${
              !inFrame
                ? `calc(${sidebar.opened ? 232 : 56}px - ${
                    asideRightBl || isNoMenus
                      ? `${sidebar.opened ? 176 : 0}px`
                      : '0px'
                  })`
                : '0'
            };`
          : ''
      "
    >
      <div v-show="layout !== 'div'" id="appViewBox">
        <div class="app-view-box" v-html="content" />
      </div>
    </section>
  </div>
</template>
<script>
import Layout from "@/layout";
import { constantRoutes } from "@/router";
import { parseUrl } from "@/utils/helper";
import { getToken, setToken, getUser, setUser } from "@/utils/auth";
import { mapGetters } from "vuex";
// import store from "@/store";
export default {
  components: {
    Layout
  },
  props: {
    loading: Boolean,
    content: String
  },
  data() {
    return {
      isRouterAlive: true,
      load: {},
      locale: this.$i18n.messages[this.$store.state.app.language],
      firstAppearBl: false, // '首次进入页面埋点请求'
      asideRightBl: false // 用于显示部分不需要受越权
    };
  },
  computed: {
    ...mapGetters(["sidebar"]),
    /* 主项目的路由 */
    mainUrls() {
      return constantRoutes.map(item => item.path);
    },
    appUrls() {
      const { microAppRoutes } = this.$store.getters;
      return (
        microAppRoutes &&
        microAppRoutes
          .filter(
            item => item.path !== "/report" && item.path !== "/model-fastview"
          )
          .map(item => {
            let path = item.path;
            if (path.indexOf("product") > -1) {
              const urls = parseUrl(path);
              path = decodeURIComponent(urls.query.product);
            }
            return path;
          })
      );
    },
    layout() {
      // div表示没有layout
      let layout = "div";
      let publicPath = this.publicPath;
      const { query } = this.$route;
      if (query && query.product) {
        publicPath = decodeURIComponent(query.product);
      }
      if (
        this.appUrls &&
        this.appUrls.length &&
        this.appUrls.includes(publicPath)
      ) {
        layout = "Layout";
      }
      return layout;
    },
    /* 
      路由首段
      如 /newcar /enterprise 等
    */
    publicPath() {
      let { path } = this.$route;
      return path
        .split("/")
        .slice(0, 2)
        .join("/");
    },
    inFrame() {
      return parent !== window;
    },
    language() {
      return this.$i18n.locale;
    },
    isNoMenus() {
      return ["multidimensional-query", "sq"].some(
        n => this.$route.path.indexOf(n) > -1
      );
    }
  },
  watch: {
    loading() {
      if (this.loading) {
        this.load = this.$loading({
          lock: true,
          text: "加载中...",
          spinner: "iw-icon-loading",
          background: "rgba(0, 0, 0, 0.1)",
          target: document.querySelector("#appViewBox")
        });
      } else {
        this.load.close();

        const token = getToken();
        const user = getUser();
        if (token) setToken(token);
        if (user) setUser(user);
      }
    },
    "$i18n.locale"() {
      this.reload();
    }
  },
  created() {
    // console.log("locale", this.$i18n.messages[this.$store.state.app.language]);
    this.locale = this.$i18n.messages[this.$store.state.app.language];
  },
  mounted() {
    window.document.documentElement.setAttribute(
      "data-theme",
      this.$store.state.settings.theme
    );
  },
  methods: {
    reload() {
      this.isRouterAlive = false;
      this.$nextTick(function() {
        this.isRouterAlive = true;
      });
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~@/styles/variables.scss";
.sub-app-container {
  background: #fff;
  transition: padding-left 0.3s;

  #appViewBox {
    width: 100%;
    height: 100%;
    .app-view-box {
      width: 100%;
      height: 100%;
    }
  }
}
</style>
